import { ChildrenProps } from './components/utils';
import { Fallback } from './fallback';
import { ErrorBoundary as Base } from 'react-error-boundary';

export const ErrorBoundary: React.FC<ChildrenProps> = ({ children }) => {
  return <Base fallback={<Fallback />}>{children}</Base>;
};
